import { render, staticRenderFns } from "./MaterialMapperAdd.vue?vue&type=template&id=13ff2ee2&"
import script from "./MaterialMapperAdd.vue?vue&type=script&lang=js&"
export * from "./MaterialMapperAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports